import { Group as IconGroup, InfoIcon } from '@shared/assets';
import type { Group } from '@shared/types/common';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';
import { Toggle } from './toggle';
import { Tooltip } from '@mui/material';

type Props = {
  group: Group;
  removeFromSelectedGroups: (group: Group) => void;
  addSelectedToGroups: (group: Group) => void;
  isSelectedAtAnyGroups: (group: Group) => boolean;
};

export const AllToggle: React.FC<Props> = ({
  group,
  isSelectedAtAnyGroups,
  removeFromSelectedGroups,
  addSelectedToGroups,
}) => {
  const description = `Если настройка “Для всех” включена, доступ к программе будут иметь все существующие
            группы, отмеченные галочкой, и созданные в будущем. Ограничить доступ можно сняв галочку
            с конкретной группы`;
  return (
    <Card className={st.all}>
      <div className={st.title}>
        <div className={st.nameBlock}>
          <span className={st.groupIcon}>
            <IconGroup />
          </span>
          {group.name}
          <span>
            <Tooltip title={description}>
              <span>
                <InfoIcon />
              </span>
            </Tooltip>
          </span>
        </div>
        <Toggle
          group={group}
          isSelectedAtAnyGroups={isSelectedAtAnyGroups}
          addSelectedToGroups={addSelectedToGroups}
          removeFromSelectedGroups={removeFromSelectedGroups}
        />
      </div>
    </Card>
  );
};
